var map = {
	"./aiSecurity/sc.json": [
		4250,
		66
	],
	"./dataLeakage/sc.json": [
		4251,
		69
	],
	"./ppd/sc.json": [
		4252,
		72
	],
	"./ransomware/sc.json": [
		4253,
		75
	],
	"./socialMedia/sc.json": [
		4254,
		78
	],
	"./whatsApp/sc.json": [
		4255,
		81
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1427;
module.exports = webpackAsyncContext;